import { render, staticRenderFns } from "./FlavorItem.vue?vue&type=template&id=49ada688&scoped=true&"
import script from "./FlavorItem.vue?vue&type=script&lang=js&"
export * from "./FlavorItem.vue?vue&type=script&lang=js&"
import style0 from "./FlavorItem.vue?vue&type=style&index=0&id=49ada688&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ada688",
  null
  
)

export default component.exports